import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { AuthState, UserInfo } from '@/types/auth'

interface AuthActions {
  setAuth: (
    token: string,
    refreshToken: string,
    user: UserInfo,
    permissions?: string[]
  ) => void
  setUser: (user: UserInfo) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  setLoginType: (type: 'enterprise' | 'qrcode' | null) => void
  clearAuth: () => void
  updateToken: (token: string, refreshToken?: string) => void
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  token: null,
  refreshToken: null,
  permissions: [],
  loginType: null,
  loading: false,
  error: null
}

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set, get) => ({
      ...initialState,

      setAuth: (token, refreshToken, user, permissions) => {
        set({
          isAuthenticated: true,
          token,
          refreshToken,
          user,
          permissions,
          loading: false,
          error: null
        })
      },

      setUser: (user) => {
        set({ user })
      },

      setLoading: (loading) => {
        set({ loading })
      },

      setError: (error) => {
        set({ error, loading: false })
      },

      setLoginType: (loginType) => {
        set({ loginType })
      },

      clearAuth: () => {
        set({
          ...initialState
        })
      },

      updateToken: (token, refreshToken) => {
        const currentState = get()
        set({
          token,
          refreshToken: refreshToken || currentState.refreshToken
        })
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        token: state.token,
        refreshToken: state.refreshToken,
        permissions: state.permissions,
        loginType: state.loginType
      })
    }
  )
)
